import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { acknowledgeRender, acknowledgeSwap } from 'components/collage/CollageSlice.js'

// Components
import Block from './Block.js'
import {getResizedPhoto} from 'lib/Helpers.js';

// CSS
import './Collage.css';

// Number of photos to for each stage
// ie. stage one is up until 10 photos
const RENDER_STAGE_1 = 15;
const RENDER_STAGE_2 = 30;
const RENDER_STAGE_3 = 50;

// How often to re-render at various stages
const DEFAULT_FREQ = 2000;
const STAGE_1_FREQ = 2000;
const STAGE_2_FREQ = 2000;
const STAGE_3_FREQ = 3000;


class Collage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      rendering: false,
      blocks: {},
      renderStamp: null,
    }

    this.renderFrequency  = DEFAULT_FREQ;
    this.renderIntervalId = null;

    this._renderTimeoutId = null;
  }
  
  shouldComponentUpdate(nextProps, nextState) {
    return (nextProps.collage.needRender !== false 
      || this.state.rendering !== nextState.rendering 
      || this.state.renderStamp != nextState.renderStamp 
      || this.props.collage.swap.length != nextProps.collage.swap.length
      || this.props.collage.backgroundColor != nextProps.collage.backgroundColor
      || this.props.collage.resolution.width != nextProps.collage.resolution.width
      || this.props.collage.resolution.height != nextProps.collage.resolution.height
      || this.props.scale != nextProps.scale
      || this.props.exportStep != nextProps.exportStep
    );
  }


  componentDidMount() { 
    this.gandrWorker = new Worker('js/gw.js');
    this.gandrWorker.addEventListener('message', this.algoDone, false);
    // this.renderInterval = setInterval(this.pushQueue, this.renderFrequency);
    this.state.rendering = true;
    this.renderCollage();
  }

  componentDidUpdate(prevProps, prevState) {

    if ( this.props.collage.swap.length === 2 ) { 
      let tmpBlocks = Object.assign({}, this.state.blocks);

      let obj0 = Object.assign({}, tmpBlocks[this.props.collage.swap[0]]);
      let obj1 = Object.assign({}, tmpBlocks[this.props.collage.swap[1]]);

      tmpBlocks[this.props.collage.swap[0]].gandr_pos = Object.assign({}, obj1.gandr_pos);
      tmpBlocks[this.props.collage.swap[0]].gandr_size = Object.assign({}, obj1.gandr_size);

      tmpBlocks[this.props.collage.swap[1]].gandr_pos = Object.assign({}, obj0.gandr_pos);
      tmpBlocks[this.props.collage.swap[1]].gandr_size = Object.assign({}, obj0.gandr_size);

      tmpBlocks[this.props.collage.swap[0]] = getResizedPhoto(tmpBlocks[this.props.collage.swap[0]], 0, 0);
      tmpBlocks[this.props.collage.swap[1]] = getResizedPhoto(tmpBlocks[this.props.collage.swap[1]], 0, 0);

      this.props.acknowledgeSwap();
    }

    // Not checking against this.state.rendering here because we want to reset the timeout when another render is needed
    if ( this.props.collage.needRender !== false) {
      clearTimeout(this._renderTimeoutId);
      this.state.rendering = true;
      this._renderTimeoutId = setTimeout(this.renderCollage, this.props.collage.needRender);
    }

    // if ( this.props.collage.borderWidth != prevProps.collage.borderWidth) {
    //   this.borderAlgo();
    // }

  }

  /**
   * Submits all selected photos to the gandr processer to be rendered
   */
  renderCollage = () => {
    this.runAlgo();
    this.props.acknowledgeRender();
  }

  /**
   * Runs the Gandr algorithm
   */
  runAlgo = () => {
    let args = {
      action: 'full_render',
      measurement: this.props.collage.resolution,
      photos: this.props.collage.photos.chosenNodes,
      numPhotos: this.props.collage.photos.numChosen,
      shuffle: this.props.collage.shuffle,
      collageMode: this.props.collage.layout,
      borderWidth: this.props.collage.borderWidth
    }

    this.gandrWorker.postMessage(args); // Send data to our worker.
  }

  /**
   * Update border sizes
   * 
   * @param {*} e 
   */
  // borderAlgo = () => {
  //   let args = {
  //     action: 'border_change',
  //     measurement: this.props.collage.resolution,
  //     photos: this.state.blocks,
  //     borderWidth: this.props.collage.borderWidth
  //   }
  //   this.gandrWorker.postMessage(args); // Send data to our worker.
  // }

  /**
   * When Gandr algorithm is complete
   */
  algoDone = (e) => {
    // console.log('algoDone');
    // console.log(e.data);

    if ( e.data.photos ) {
      this.setState({
        rendering: false,
        blocks: e.data.photos,
        renderStamp: e.data.stamp
      })
    }
    else {
      this.setState({
        rendering: false,
        blocks: {}
      })
    }
    
  }

  render() {
    
    let className = ['Collage'];

    className.push('Collage--' + (this.props.collage.resolution.ratio.isPortrait ? 'Portrait' : 'Landscape'));

    // Swap the positions of the selected blocks
    if ( this.props.collage.swap.length === 1 ) { 
      className.push('Collage--SwapActive');
    }

    // if ( this.props.collage.borderWidth > 0 ) {
    //   className.push('Collage--HasBorder');
    // }

    let styles = {
      backgroundColor: this.props.collage.backgroundColor,
      width: this.props.collage.resolution.width,
      height: this.props.collage.resolution.height,
      transform: 'scale('+this.props.scale+')'
      // padding: this.props.collage.borderWidth
    };
    
    return (
      <div id="Collage" className={className.join(' ')} style={styles}>
       
        {Object.keys(this.state.blocks).map(src => {
          return <Block exportStep={this.props.exportStep} key={src} photo={{src: src, ...this.state.blocks[src]}} />
        })}

        {(this.props.exportStep == 3) &&

          this.props.collage.texts.map((textObj, index) => {
            let scaleMultiplier = (1 / this.props.scale);
            const style = {
              width: textObj.positioning.width * scaleMultiplier,
              height: textObj.positioning.height * scaleMultiplier,
              left: textObj.positioning.left,
              top: textObj.positioning.top,
              transform: 'rotate('+textObj.positioning.rotate+')',
              fontSize: textObj.fontSize * scaleMultiplier,
              fontWeight: textObj.fontWeight,
              fontStyle: textObj.fontStyle,
              textDecoration: textObj.textDecoration,
              color: textObj.color,
              padding: 9 * scaleMultiplier
            }
            return <div 
              style={style}
              key={index} 
              className={'ExportText'}
              dangerouslySetInnerHTML={{ __html: textObj.text}}
            />
          })

        }
       
      </div>
    );
  }
}

const mapStateToProps = state => ({
  collage: state.collage
});

export default connect(
  mapStateToProps,
  {acknowledgeRender, acknowledgeSwap}
)(Collage)
